export const defaultTableColumns = [
  {
    field: 'title',
    title: '标题',
    width: '230',
  },
  {
    field: 'type',
    title: '类型',
    width: '194',
  },
  {
    field: 'issuerPersonName',
    title: '发布人',
    width: '194',
  },
  {
    field: 'issuerDate',
    title: '发布时间',
    width: '194',
  },
  {
    field: 'createPersonName',
    title: '创建人',
    width: '194',
  },
  {
    field: 'gmtCreate',
    title: '创建时间',
    width: '230',
  },
];
